module.exports = __webpack_public_path__ + "img/jr_banner.10b61875.jpg";